package de.connect2x.timmy

object GlobalCustomConfig {
    var CSV_EXPORT_DISABLED = true
    var filePreviewDisabled = true
}
